import { type ShapeOptions } from '@mui/system';

/**
 * Shapes. See options and defaults at https://mui.com/material-ui/customization/default-theme/
 */
export const shape: ShapeOptions = {
	borderRadius: 3,
};
